export default new class Header {
    constructor() {
        this.orderIcon = '.js-orderIcon';
        this.orderList = '.js-orderList';
    }

    init() {
        this.bindEvents();
    }

    toggleOrderDropdown ($elem) {
        let $icon = $elem.closest(this.orderIcon),
            $list = $icon.find(this.orderList);

        $list.toggleClass('_active');
    }



    bindEvents() {
        $(document)
            .on('click', this.orderIcon, (e) => {
                e.stopPropagation();
                this.toggleOrderDropdown($(e.target));
            })
            .on('click', () => {
                if ($(this.orderList).hasClass('_active')) {
                    this.toggleOrderDropdown($(this.orderIcon));
                }
            });
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/header/header.js